import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'                  //首页
import City from '@/pages/Index/city'              //城市选择
import UserLogin from '@/pages/User/login'         //登录
import UserRegister from '@/pages/User/register'   //注册
import UserBindMobile from '@/pages/User/bindMobile' //绑定手机号
import UserForget from '@/pages/User/forget'       //忘记密码
import SearchIndex from '@/pages/Search/details'    //搜索页
import SearchList from '@/pages/Search/list'       //搜索列表
//会议
import MeetingIndex from '@/pages/Meeting/index'   //会议首页 
import MeetingDetails from '@/pages/Meeting/details'  //会议详情
import MeetingPassword from '@/pages/Meeting/password'  //会议密码
import MeetingLive from '@/pages/Meeting/live'           //会议直播(日程安排)
import MeetingCalendar  from '@/pages/Meeting/calendar'     //会议日历
import MeetingList from '@/pages/meeting/List'              //会议列表        
import ExclusiveViewList from '@/pages/exclusiveView/List'     //会议专访
import MeetingSearch from '@/pages/meeting/search'                   //会议搜索
import MeetingSchedule from '@/pages/meeting/schedule'      //会议日程首页
import MeetingScheduleDetails from '@/pages/meeting/scheduleDetails'               //会议日程
import MeetingShowRoom from '@/pages/meeting/onlineShowRoom'         //会议线上展厅
import MeetingImage from '@/pages/meeting/image'                     //会议按钮图片
import ExpertSearch from '@/pages/Expert/Search'                     //专家搜索
import ExpertDetails from '@/pages/Expert/Details'                  //专家详情
import ExpertSchedule from '@/pages/Expert/Schedule'                  //专家日程
import ColumnIndex from '@/pages/Column/Index'                       //专栏首页
import ColumnDetails from '@/pages/Column/details'                   //专栏详情
import ColumnHospital from '@/pages/Column/hospital'                 //专栏医院
import HospitalSearch   from '@/pages/Column/hospitalSearch'         //医院文章搜索
import ColumnSearch from '@/pages/Column/search'                     //专栏搜索
import HospitalMe from '@/pages/Column/me'    //我的
//病例
import CaseIndex from '@/pages/Case/index'                           //病例首页
import CaseList from '@/pages/Case/list'                             //病例亚专业列表
import CaseSearch from '@/pages/Case/search'                        //病例搜索
//器械
import InstrumentIndex from '@/pages/Instrument/index'                //器械首页
import InstrumentDetails from '@/pages/Instrument/details'            //器械详情页
import InstrumentBrand from '@/pages/Instrument/brand'            //器械种类
import InstrumentSearch from '@/pages/Instrument/search'             //器械搜索
import InstrumentClassify from '@/pages/Instrument/classify'  //器械种类详情
//前沿资讯
import InformationIndex from '@/pages/information/Index'              //前沿资讯
import InformationDetails from '@/pages/information/Details'          //前沿资讯详情
import ArticleDetails from '@/pages/ExclusiveView/Details'     //文章详情

//指南
import Guide from '@/pages/Guide/newIndex'                   //指南

//我的
import PersonalIndex from '@/pages/personal/Index'          //我的
import PersonalInfo from '@/pages/personal/PersonalInfo'     //个人信息
import PersonalAttention from '@/pages/personal/MyAttention'  //我的关注
import PersonalCollect from '@/pages/personal/MyCollect'  //我的收藏

//vow
import VowIndex from '@/pages/Vow/Index'        //vow首页
import VowSearch from '@/pages/Vow/Search/Index' //vow搜索
import  VowSearchList from '@/pages/Vow/Search/List'    //vow列表

//上传证书
import UploadCert from '@/pages/UploadCert';          //上传证书

//授权
import Wechatauth from '@/pages/Wechatauth';          //上传证书       

//血管资讯会议系统（新）
import VascularIndex from '@/pages/VascularSystem/Index/Index';          //首页
import NewMeetingIndex from '@/pages/VascularSystem/Meeting/Index';          //新会议首页
import NewMeetingLive from '@/pages/VascularSystem/Meeting/Live';          //新会议直播
import LiveDetail from '@/pages/VascularSystem/Meeting/LiveDetail';          //新会议直播
import NewMeetingFiles from '@/pages/VascularSystem/Meeting/Files';          //新会议资料下载
import NewMeetingPassword from '@/pages/VascularSystem/Meeting/password'  //会议密码
import VascularCalendar from '@/pages/VascularSystem/Calendar/Calendar';          //会议日历
import VascularSearch from '@/pages/VascularSystem/Calendar/Search';          //会议日历
import WikiIndex from '@/pages/VascularSystem/wiki/index';          //wiki海报

import VascularCompany from '@/pages/VascularSystem/Company/Company';          //企业
import Exhibition from '@/pages/VascularSystem/Company/Exhibition';          //企业
import CompanyIndex from '@/pages/VascularSystem/Company/Index';          //企业主页
import CompanyLive from '@/pages/VascularSystem/Company/Live';          //企业直播
import VascularMessage from '@/pages/VascularSystem/Message/Index';          //消息
import SystemMessage from '@/pages/VascularSystem/Message/SystemMessage';          //系统消息
import DateMessage from '@/pages/VascularSystem/Message/DateMessage';          //日程消息
import VascularPersonal from '@/pages/VascularSystem/Personal/Index';          //我的
import MyInfo from '@/pages/VascularSystem/Personal/MyInfo';          //我的信息
import Setting from '@/pages/VascularSystem/Personal/Setting';          //设置
import Login from '@/pages/VascularSystem/User/Login';          //登录
// import ChangeMobile from '@/pages/VascularSystem/User/ChangeBindMobile';          //改绑定手机
import BindNew from '@/pages/VascularSystem/User/BindNew';          //改绑定手机
import CreditAuth from '@/pages/VascularSystem/User/CreditAuth';          //身份认证
import TaskBook from '@/pages/VascularSystem/TaskBook/Index';          //任务书
// import TaskBookDetail from '@/pages/VascularSystem/TaskBook/TaskDetail';          //任务书详情
import TaskBookDetail from '@/pages/VascularSystem/TaskBook/Task';          //任务书详情
import TaskBookPdf from '@/pages/VascularSystem/TaskBook/TaskPdf';          //任务书详情pdf
import TaskBookDetailNew from '@/pages/VascularSystem/TaskBook/Outer';          //任务书详情(外部)
import NewExpertSearch from '@/pages/VascularSystem/Expert/Search'                     //专家搜索
import ExpertSearchAll from '@/pages/VascularSystem/Expert/SearchAll'                     //全部专家搜索
import ExpertDetail from '@/pages/VascularSystem/Expert/Detail'                     //专家详细日程
import ExpertIndex from '@/pages/VascularSystem/Expert/Index'                     //专家主页
import ExpertRecord from '@/pages/VascularSystem/Expert/Record'                     //专家视频
import MeetingInfo from '@/pages/VascularSystem/Meeting/MeetingInfo'                     //大会信息
import NewMeetingSchedule from '@/pages/VascularSystem/Meeting/Schedule'      //新会议日程首页
import ScheduleResult from '@/pages/VascularSystem/Meeting/ScheduleResult'      //新会议日程首页
import ScheduleList from '@/pages/VascularSystem/Meeting/ScheduleList'      //日程列表


import NewMeetingScheduleDetails from '@/pages/VascularSystem/Meeting/ScheduleDetail'//新会议日程
// import NewPersonalAttention from '@/pages/vascularSystem/personal/myAttention'  //我的关注
import NewPersonalCollect from '@/pages/VascularSystem/Personal/MyCollect'  //我的收藏
import Registration from '@/pages/VascularSystem/Meeting/Registration'  //注册参会
import Eposter from '@/pages/VascularSystem/Meeting/Eposter'  //壁报
import EposterLink from '@/pages/VascularSystem/Meeting/EposterLink'  //壁报(链接版)
import PPTs from '@/pages/VascularSystem/Meeting/PPTs'  //PPT

import Manual from '@/pages/VascularSystem/Meeting/Manual'  //手册
import ShowPdf from '@/pages/VascularSystem/Meeting/ShowPdf'  //pdf预览
//注册收费
import ChargeIndex from '@/pages/VascularSystem/Meeting/charge' 
import ChargeRegister from '@/pages/VascularSystem/Meeting/chargeRegister'//收费注册
import regionIndex from '@/pages/region/Index'  //专区
import Video from '@/pages/Region/Video'  //专区

//支付注册
import ChargeInfoIndex from '@/pages/VascularSystem/ChargeInfo/index' 
import ChargeCollectInfo from "@/pages/VascularSystem/ChargeInfo/collectInfo"
import ChargeCollecOrderInfo from '@/pages/VascularSystem/ChargeInfo/orderInfo'

// 购买收费
// import BookChargeInfoIndex from '@/pages/VascularSystem/book/index' 
// import BookChargeCollectInfo from "@/pages/VascularSystem/book/collectInfo"
import BookChargeCollectInfo2 from "@/pages/VascularSystem/book/collectInfo2"

import BookChargeInfoIndex2 from "@/pages/VascularSystem/book/index2"

// import BookChargeCollecOrderInfo from '@/pages/VascularSystem/book/ChargeInfo/orderInfo'
//短信
import codeSchedule from '@/pages/Expert/codeSchedule'  //专区

//讲题征稿及劳务收费系统
import contibutionIndex from '@/pages/contributions/index'  //首页
import contibutionBind from '@/pages/contributions/bind'  //绑定手机
import contibutionContact from '@/pages/Contributions/contact'  //联系
import contibutionPersonal from '@/pages/Contributions/personal'  //个人信息
import contibutionSubject from '@/pages/Contributions/subject'  //课题
import contibutionUpload from '@/pages/Contributions/upload'  //课题上报
import contibutionFee from '@/pages/Contributions/fee'  //劳务费上报

//cec2022
import cecIndex from '@/pages/cec2022/index'  //首页
import cec2023Index from '@/pages/cec2023/index'  //首页
import cecInfo from '@/pages/cec2022/info'  //大会信息
import cecOrganizor from '@/pages/cec2022/organizor'  //组织机构
import cecContact from '@/pages/cec2022/contact'  //联系我们
import cecDownload from '@/pages/cec2022/download'  //下载
import cecPersonal from '@/pages/cec2022/personal'  //下载
import cecPPTs from '@/pages/cec2022/PPTs'  //PPT
import coming from '@/pages/cec2022/toContinue'  //敬请期待
import coming2023 from '@/pages/cec2023/toContinue'  //敬请期待

import CECStatic from '@/pages/cec2022/staticBg'  
import CECDynamic from '@/pages/cec2022/dynamicBg'  
import CECZoom from '@/pages/cec2022/zoom'  
import CECVirtual from '@/pages/cec2022/virtual'  
import CECUseZoom from '@/pages/cec2022/useZoom'  
import CECSchedule from '@/pages/cec2022/schedule'  
import CECInvite from '@/pages/cec2022/invite'  
import CECSchedulePoster from '@/pages/cec2022/schedulePoster'  
import CECAppDownload from '@/pages/cec2022/appDownload'  
//cec2023
import cec2023Info from '@/pages/cec2023/info'
//CVSCF2023
import cvscfIndex from '@/pages/CVSCF2023/index'  //首页
import cvscfDownload from '@/pages/CVSCF2023/download'  //资料下载
import cvscfHotel from '@/pages/CVSCF2023/hotel'  //酒店信息
import cvscfPPTs from '@/pages/CVSCF2023/PPTs'  //PPT
import cvscfInvite from '@/pages/CVSCF2023/invite'  

//TECross2023

import tecrossIndex from '@/pages/TECross2023/index'  //首页

//XVC
import xvcIndex from '@/pages/XVC/index'  //首页
import xvcIndex2025 from '@/pages/XVC/index598'  //首页

import xvcDownload from '@/pages/XVC/download'  //资料下载
import xvcHotel from '@/pages/XVC/hotel'  //酒店信息
import xvcPPTs from '@/pages/XVC/PPTs'  //PPT
import xvcInvite from '@/pages/XVC/invite'  
import xvcHistory from '@/pages/XVC/history'  

// NVC
import nvcDownload from '@/pages/NVC2025/download' 
Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta:{
        title:'血管资讯'
      }
    },
    //授权
    {
      path: '/wechatauth',
      name: 'Wechatauth',
      component: Wechatauth,
      meta:{
        title:'血管资讯'
      }
    },
    //上传证书
    {
      path: '/uploadCert',
      name: 'UploadCert',
      component: UploadCert,
      meta:{
        title:'上传证书'
      }
    },
    //绑定手机号
    {
      path: '/user/bindMobile',
      name: 'UserBindMobile',
      component: UserBindMobile,
      meta:{
        title:'绑定手机号'
      }
    },
    //登录
    {
      path: '/user/login',
      name: 'UserLogin',
      component: UserLogin,
      meta:{
        title:'登录'
      }
    },
    //注册
    {
      path: '/user/register',
      name: 'UserRegister',
      component: UserRegister,
      meta:{
        title:'注册'
      }
    },
    //忘记密码
    {
      path:'/user/forget',
      name:'UserForget',
      component:UserForget,
      meta:{
        title:'忘记密码'
      }
    },
    //搜索
    {
    	path:'/search/search',
    	name:'SearchIndex',
    	component:SearchIndex
    },
    {
      path:'/search/list',
      name:'SearchList',
      component:SearchList
    },
    //城市选择
    {
    	path:'/city/city',
    	name:'City',
    	component:City,
      meta:{
        title:'选择城市'
      }
    },
    {
      path:'/guide',
    	name:'Guide',
    	component:Guide,
      meta:{
        title:'指南/共识'
      }
    },
    //会议首页
    {
      path:'/meeting/index',
      // path:'/',
      name:'MeetingIndex',
      component:MeetingIndex,
      meta:{
        title:'会议'
      }
    },
    //会议密码
    {
      path:'/meeting/password',
      name:'MeetingPassword',
      component:MeetingPassword,
      meta:{
        title:'入会密码'
      }
    },
    //会议详情
    {
      path:'/meeting/details',
      name:'MeetingDetails',
      component:MeetingDetails,
      meta:{
        title:'会议详情'
      }
    },
    //会议列表
    {
      path:'/meeting/list',
      name:'MeetingList',
      component:MeetingList,
      meta:{
        title:'会议列表'
      }
    },
    //会议直播
    {
      path:'/meeting/live',
      name:'MeetingLive',
      component:MeetingLive,
      meta:{
        title:'会议直播'
      }   
    },
    //会议日历
    {
      path:'/meeting/calendar',
      name:'MeetingCalendar',
      component:MeetingCalendar,
      meta:{
        title:'会议日历',
        // keepAlive:true
      }        
    },
    //会议搜索
    {
      path:'/meeting/search',
      name:'MeetingSearch',
      component:MeetingSearch,
      meta:{
        title:'会议搜索'
      }     
    },
    //会场日程
    {
      path:'/meeting/schedule',
      name:'MeetingSchedule',
      component:MeetingSchedule,
      meta:{
        title:'会议日程'
      }
    },
    //会议日程详情
    {
      path:'/meeting/scheduleDetails',
      name:'MeetingScheduleDetails',
      component:MeetingScheduleDetails,
      meta:{
        title:'日程详情'
      }
    },     
    //线上展厅
    {
      path:'/meeting/showroom',
      name:'MeetingShowRoom',
      component:MeetingShowRoom,
      meta:{
        title:'线上展厅'
      }
    },
    //会议按钮图片
    {
      path:'/meeting/image',
      name:'MeetingImage',
      component:MeetingImage,
    },
    //会议专访
    {
      path:'/exclusiveView/list',
      name:'ExclusiveViewList',
      component:ExclusiveViewList,
      meta:{
        title:'会议专访'
      } 
    },
    //专家搜索
    {
      path:'/expert/search',
      name:'ExpertSearch',
      component:ExpertSearch,
      meta:{
        title:'专家搜索'
      }  
    },
    //专家日程
    {
      path:'/expert/schedule',
      name:'ExpertSchedule',
      component:ExpertSchedule,
      meta:{
        title:'专家日程'
      } 
    },
    //专家详情
    {
      path:'/expert/details',
      name:'ExpertDetails',
      component:ExpertDetails,
      meta:{
        title:'专家详情'
      }  
    },
    //专栏首页
    {
      path:'/column/index',
      name:'ColumnIndex',
      component:ColumnIndex,
      meta:{
        title:'专栏'
      }
    },
    //专栏详情
    {
      path:'/column/details',
      name:'ColumnDetails',
      component:ColumnDetails,
      meta:{
        title:'专栏详情'
      }      
    },
    //医院专栏详情
    {
      path:'/column/hospital',
      name:'ColumnHospital',
      component:ColumnHospital,
      meta:{
        title:'专栏详情'
      }      
    },
    //医院文章搜索
    {
      path:'/column/hospitalSearch',
      name:'HospitalSearch',
      component:HospitalSearch,
      meta:{
        title:'文章列表'
      }
    },
    //我的
    {
      path:'/column/me',
      name:'HospitalMe',
      component:HospitalMe,
      meta:{
        title:'个人中心'
      }
    },
    //专栏搜索
    {
      path:'/column/search',
      name:'ColumnSearch',
      component:ColumnSearch,
      meta:{
        title:'搜索'
      }      
    },
    //病例
    {
      path:'/case/index',
      name:'CaseIndex',
      component:CaseIndex,
      meta:{
        title:'病例'
      }
    },
    //病例亚专业列表
    {
      path:'/case/list',
      name:'CaseList',
      component:CaseList,
      meta:{
        title:'亚专业'
      }
    },
    //病例搜索
    {
      path:'/case/search',
      name:'CaseSearch',
      component:CaseSearch,
      meta:{
        title:'搜索'
      }
    },
    //器械
    {
      path:'/instrument/index',
      name:'InstrumentIndex',
      component:InstrumentIndex,
      meta:{
        title:'器械百科'
      }
    },
    //器械详情
    {
      path:'/instrument/details',
      name:'InstrumentDetails',
      component:InstrumentDetails,
      meta:{
        title:'器械百科'
      }
    },
    //器械种类
    {
      path:'/instrument/brand',
      name:'InstrumentBrand',
      component:InstrumentBrand,
      meta:{
        title:'器械品牌'
      }
    },
    //器械搜索
    {
      path:'/instrument/search',
      name:'InstrumentSearch',
      component:InstrumentSearch,
      meta:{
        title:'器械搜索'
      }
    },
    //器械种类详情
    {
      path:'/instrument/classify/:id',
      name:'InstrumentClassify',
      component:InstrumentClassify,
      meta:{
        title:'器械种类'
      }
    },
    //前沿资讯首页
    {
      path:'/information/index',
      name:'InformationIndex',
      component:InformationIndex,
      meta:{
        title:'前沿资讯'
      }
    },
    //前沿资讯详情
    {
      path:'/information/details',
      name:'InformationDetails',
      component:InformationDetails,
      meta:{
        title:''
      }
    },
    //文章详情
    {
      path:'/exclusiveView/details',
      name:'ArticleDetails',
      component:ArticleDetails,
      meta:{
        title:'文章详情'
      } 
    },
    //我的-首页
    {
      path:'/personal/index',
      name:'PersonalIndex',
      component:PersonalIndex,
      meta:{
        title:'个人中心',
        keepAlive:true
      }       
    },
    //我的-个人信息
    {
      path:'/personal/info',
      name:'PersonalInfo',
      component:PersonalInfo,
      meta:{
        title:'个人信息',
      }
    },
    //我的-我的关注
    {
      path:'/personal/attention',
      name:'PersonalAttention',
      component:PersonalAttention,
      meta:{
        title:'我的关注'
      }
    },
    //我的-我的收藏
    {
      path:'/personal/collect',
      name:'PersonalCollect',
      component:PersonalCollect,
      meta:{
        title:'我的收藏'
      }
    },
    //VOW-首页
    {
      path:'/vow/index',
      name:'VowIndex',
      component:VowIndex,
      meta:{
        title:'vow首页'
      }
    },
    //VOW-搜索
    {
      path:'/vow/search',
      name:'VowSearch',
      component:VowSearch,
      meta:{
        title:'搜索'
      }
    },
    //VOW-搜索列表
    {
      path:'/vow/search/list',
      name:'VowSearchList',
      component:VowSearchList,
      meta:{
        title:'搜索'
      }
    },
    //专区
    {
      path:'/region',
      name:'RegionIndex',
      component:regionIndex,
      meta:{
        title:'专区'
      }
    },
    //视频
    {
      path:'/video',
      name:'Video',
      component:Video,
      meta:{
        title:'视频'
      }
    },
    //血管资讯
    //首页
    {
      path:'/vascularNews',
      name:'VascularIndex',
      component:VascularIndex,
      meta:{
        title:'血管资讯会议系统'
      }
    },
    //首页
    {
      path:'/vascularNews/meeting/Index',
      name:'NewMeetingIndex',
      component:NewMeetingIndex,
      meta:{
        title:''
      }
    },
    //资料下载
    {
      path:'/vascularNews/meeting/files',
      name:'NewMeetingFiles',
      component:NewMeetingFiles,
      meta:{
        title:''
      }
    },
    
    //首页
    {
      path:'/vN/MT/index',
      name:'NewMeetingIndexShort',
      component:NewMeetingIndex,
      meta:{
        title:''
      }
    },
     {
      path:'/vascularNews/meeting/password',
      name:'NewMeetingPassword',
      component:NewMeetingPassword,
      meta:{
        title:'大会密码'
      }
    },
    //会议日历
    {
      path:'/vascularNews/calendar',
      name:'VascularCalendar',
      component:VascularCalendar,
      meta:{
        title:'会议日历'
      }
    },
     //wiki海报
     {
      path:'/vascularNews/wiki',
      name:'WikiIndex',
      component:WikiIndex,
      meta:{
        title:'器械百科'
      }
    },
    //搜索
    {
      path:'/vascularNews/search',
      name:'VascularSearch',
      component:VascularSearch,
      meta:{
        title:'搜索'
      }
    },
    //企业
    {
      path:'/vascularNews/company',
      name:'VascularCompany',
      component:VascularCompany,
      meta:{
        title:'企业专区'
      }
    },
    //企业专区 无tabbar
    {
      path:'/vascularNews/exhibition',
      name:'Exhibition',
      component:Exhibition,
      meta:{
        title:'企业专区'
      }
    },
    //企业主页
    {
      path:'/vascularNews/company/index',
      name:'CompanyIndex',
      component:CompanyIndex,
      meta:{
        title:'企业主页'
      }
    },
    //企业主页
    {
      path:'/vascularNews/company/live',
      name:'CompanyLive',
      component:CompanyLive,
      meta:{
        title:'会议直播'
      }
    },
     //消息
     {
      path:'/vascularNews/message',
      name:'VascularMessage',
      component:VascularMessage,
      meta:{
        title:'我的消息'
      }
    },
     //系统消息
     {
      path:'/vascularNews/message/system',
      name:'SystemMessage',
      component:SystemMessage,
      meta:{
        title:'系统消息'
      }
    },
    //日程消息
    {
      path:'/vascularNews/message/date',
      name:'DateMessage',
      component:DateMessage,
      meta:{
        title:'日程消息'      
      }
    },
    //我的
    {
      path:'/vascularNews/personal',
      name:'VascularPersonal',
      component:VascularPersonal,
      meta:{
        title:'我的'
      }
    },
    //登录
    {
      path:'/vascularNews/user/login',
      name:'Login',
      component:Login,
      meta:{
        title:'登录'
      }
    },
     //身份认证
     {
      path:'/vascularNews/user/creditAuth',
      name:'CreditAuth',
      component:CreditAuth,
      meta:{
        title:'身份认证'
      }
    },
     //任务书
     {
      path:'/vascularNews/personal/taskbook',
      name:'TaskBook',
      component:TaskBook,
      meta:{
        title:'任务书'
      }
    },
    //任务书详情
    {
      path:'/vascularNews/personal/taskbookDetail',
      name:'TaskBookDetail',
      component:TaskBookDetail,
      meta:{
        title:'任务书'
      }
    },
     //任务书详情
     {
      path:'/vascularNews/personal/taskbookDetailNew',
      name:'TaskBookDetailNew',
      component:TaskBookDetailNew,
      meta:{
        title:'任务书'
      }
    },
    //任务书详情
    {
      path:'/vascularNews/personal/taskbookPdf',
      name:'TaskBookPdf',
      component:TaskBookPdf,
      meta:{
        title:'任务书'
      }
    },
    //我的信息
    {
      path:'/vascularNews/personal/myInfo',
      name:'MyInfo',
      component:MyInfo,
      meta:{
        title:'我的'
      }
    },
    
    //我的-我的收藏
    {
      path:'/vascularNews/personal/collect',
      name:'NewPersonalCollect',
      component:NewPersonalCollect,
      meta:{
        title:'我的收藏'
      }
    },
    //设置
    {
      path:'/vascularNews/personal/setting',
      name:'Setting',
      component:Setting,
      meta:{
        title:'设置'
      }
    },
    //设置
    {
      path:'/vascularNews/user/bindNew',
      name:'BindNew',
      component:BindNew,
      meta:{
        title:'绑定新手机'
      }
    },
    //专家
    {
      path:'/vascularNews/expert/search',
      name:'NewExpertSearch',
      component:NewExpertSearch,
      meta:{
        title:'专家检索'
      }
    },
    //全部专家
    {
      path:'/vascularNews/zhuanjia',
      name:'ExpertSearchAll',
      component:ExpertSearchAll,
      meta:{
        title:'专家检索',
        keepAlive: true // 需要缓存
      }
    },
    //专家日程
    {
      path:'/vascularNews/expert/detail',
      name:'ExpertDetail',
      component:ExpertDetail,
      meta:{
        title:'专家日程'
      }
    },
    //专家主页
    {
      path:'/vascularNews/expert/index',
      name:'ExpertIndex',
      component:ExpertIndex,
      meta:{
        title:'专家主页'
      }
    },
    //专家视频
    {
      path:'/vascularNews/expert/record',
      name:'ExpertRecord',
      component:ExpertRecord,
      meta:{
        title:'专家视频'
      }
    },
    //会议直播
    {
      path:'/vascularNews/meeting/live',
      name:'NewMeetingLive',
      component:NewMeetingLive,
      meta:{
        title:'会议直播'
      }
    },
    //会议详情
    {
      path:'/vascularNews/meeting/liveDetail',
      name:'LiveDetail',
      component:LiveDetail,
      meta:{
        title:'会议直播'
      }
    },
    //大会信息
    {
      path:'/vascularNews/meeting/info',
      name:'MeetingInfo',
      component:MeetingInfo,
      meta:{
        title:'大会信息'
      }
    },
    //会场日程
    {
      path:'/vascularNews/meeting/schedule',
      name:'NewMeetingSchedule',
      component:NewMeetingSchedule,
      meta:{
        title:'会议日程'
      }
    },
    {
      path:'/vascularNews/schedule/result',
      name:'ScheduleResult',
      component:ScheduleResult,
      meta:{
        title:'日程一览'
      }
    },
    //日程列表
    {
      path:'/vascularNews/meeting/scheduleList',
      name:'ScheduleList',
      component:ScheduleList,
      meta:{
        title:'日程详情'
      }
    },
    //会议日程详情
    {
      path:'/vascularNews/meeting/scheduleDetails',
      name:'NewMeetingScheduleDetails',
      component:NewMeetingScheduleDetails,
      meta:{
        title:'日程详情'
      }
    },
    //注册参会
    {
      path:'/vascularNews/meeting/register',
      name:'Registration',
      component:Registration,
      meta:{
        title:'注册参会'
      }
    }, 
    //壁报
     {
      path:'/vascularNews/meeting/eposter',
      name:'Eposter',
      component:Eposter,
      meta:{
        title:'壁报'
      }
    }, 
    //壁报
    {
      path:'/vascularNews/meeting/eposter_link',
      name:'EposterLink',
      component:EposterLink,
      meta:{
        title:'壁报'
      }
    },
    //PPT
    {
      path:'/vascularNews/meeting/ppt',
      name:'PPT',
      component:PPTs,
      meta:{
        title:'PPT模板'
      }
    }, 
    //手册
    {
      path:'/vascularNews/meeting/manual',
      name:'Manual',
      component:Manual,
      meta:{
        title:'日程手册'
      }
    }, 
    //壁报pdf
    {
      path:'/vascularNews/pdf',
      name:'ShowPdf',
      component:ShowPdf,
      meta:{
        title:'PDF'
      }
    },
    // 注册收费
    {
      path:'/vascularNews/meeting/charge',
      name:'charge',
      component:ChargeIndex,
      meta:{
        title:'注册收费'
      }
    }, 
    // 线上注册
    {
      path:'/vascularNews/meeting/chargeRegister',
      name:'chargeRegister',
      component:ChargeRegister,
      meta:{
        title:'线上注册'
      }
    }, 
   
    //短信链接
    {
      path:'/code_schedule',
      name:'codeSchedule',
      component:codeSchedule,
      meta:{
        title:'日程安排'
      }

    },
    //简写path
     //首页
     {
      path:'/vN',
      name:'VascularIndexShort',
      component:VascularIndex,
      meta:{
        title:'血管资讯会议系统'
      }
    },
     {
      path:'/vN/MT/password',
      name:'NewMeetingPasswordShort',
      component:NewMeetingPassword,
      meta:{
        title:'大会密码'
      }
    },
    //会议日历
    {
      path:'/vN/calendar',
      name:'VascularCalendarShort',
      component:VascularCalendar,
      meta:{
        title:'会议日历'
      }
    },
    //企业
    {
      path:'/vN/company',
      name:'VascularCompanyShort',
      component:VascularCompany,
      meta:{
        title:'企业专区'
      }
    },
    //企业专区 无tabbar
    {
      path:'/vN/exhibition',
      name:'ExhibitionShort',
      component:Exhibition,
      meta:{
        title:'企业专区'
      }
    },
    //企业主页
    {
      path:'/vN/company/index',
      name:'CompanyIndexShort',
      component:CompanyIndex,
      meta:{
        title:'企业主页'
      }
    },
    //企业主页
    {
      path:'/vN/company/live',
      name:'CompanyLiveShort',
      component:CompanyLive,
      meta:{
        title:'会议直播'
      }
    },
     //消息
     {
      path:'/vN/message',
      name:'VascularMessageShort',
      component:VascularMessage,
      meta:{
        title:'我的消息'
      }
    },
     //系统消息
     {
      path:'/vN/message/system',
      name:'SystemMessageShort',
      component:SystemMessage,
      meta:{
        title:'系统消息'
      }
    },
    //日程消息
    {
      path:'/vN/message/date',
      name:'DateMessageShort',
      component:DateMessage,
      meta:{
        title:'日程消息'      
      }
    },
    //我的
    {
      path:'/vN/personal',
      name:'VascularPersonalShort',
      component:VascularPersonal,
      meta:{
        title:'我的'
      }
    },
    //登录
    {
      path:'/vN/user/login',
      name:'LoginShort',
      component:Login,
      meta:{
        title:'登录'
      }
    },
     //身份认证
     {
      path:'/vN/user/creditAuth',
      name:'CreditAuthShort',
      component:CreditAuth,
      meta:{
        title:'身份认证'
      }
    },
     //任务书
     {
      path:'/vN/personal/taskbook',
      name:'TaskBookShort',
      component:TaskBook,
      meta:{
        title:'任务书'
      }
    },
    //任务书详情
    {
      path:'/vN/personal/taskbookDetail',
      name:'TaskBookDetailShort',
      component:TaskBookDetail,
      meta:{
        title:'任务书'
      }
    },
     //任务书详情
     {
      path:'/vN/personal/taskbookDetailNew',
      name:'TaskBookDetailNewShort',
      component:TaskBookDetailNew,
      meta:{
        title:'任务书'
      }
    },
    //任务书详情
    {
      path:'/vN/personal/taskbookPdf',
      name:'TaskBookPdfShort',
      component:TaskBookPdf,
      meta:{
        title:'任务书'
      }
    },
    //我的信息
    {
      path:'/vN/personal/myInfo',
      name:'MyInfoShort',
      component:MyInfo,
      meta:{
        title:'我的'
      }
    },
    
    //我的-我的收藏
    {
      path:'/vN/personal/collect',
      name:'NewPersonalCollectShort',
      component:NewPersonalCollect,
      meta:{
        title:'我的收藏'
      }
    },
    //设置
    {
      path:'/vN/personal/setting',
      name:'SettingShort',
      component:Setting,
      meta:{
        title:'设置'
      }
    },
    //设置
    {
      path:'/vN/user/bindNew',
      name:'BindNewShort',
      component:BindNew,
      meta:{
        title:'绑定新手机'
      }
    },
    //专家
    {
      path:'/vN/expert/search',
      name:'NewExpertSearchShort',
      component:NewExpertSearch,
      meta:{
        title:'专家检索',
        keepAlive: true // 需要缓存
      }
    },
    //全部专家
    {
      path:'/vN/expert/all',
      name:'ExpertSearchAllShort',
      component:ExpertSearchAll,
      meta:{
        title:'专家检索',
        keepAlive: true // 需要缓存
      }
    },
    //专家日程
    {
      path:'/vN/expert/detail',
      name:'ExpertDetailShort',
      component:ExpertDetail,
      meta:{
        title:'专家日程'
      }
    },
    //专家主页
    {
      path:'/vN/expert/index',
      name:'ExpertIndexShort',
      component:ExpertIndex,
      meta:{
        title:'专家主页'
      }
    },
    //专家视频
    {
      path:'/vN/expert/record',
      name:'ExpertRecordShort',
      component:ExpertRecord,
      meta:{
        title:'专家视频'
      }
    },
    //会议直播
    {
      path:'/vN/MT/live',
      name:'MeetingLiveShort',
      component:NewMeetingLive,
      meta:{
        title:'会议直播'
      }
    },
    //会议详情
    {
      path:'/vN/MT/liveDetail',
      name:'LiveDetailShort',
      component:LiveDetail,
      meta:{
        title:'会议直播'
      }
    },
    //大会信息
    {
      path:'/vN/MT/info',
      name:'MeetingInfoShort',
      component:MeetingInfo,
      meta:{
        title:'大会信息'
      }
    },
    //会场日程
    {
      path:'/vN/MT/schedule',
      name:'NewMeetingScheduleShort',
      component:NewMeetingSchedule,
      meta:{
        title:'会议日程'
      }
    },
    //会议日程详情
    {
      path:'/vN/MT/scheduleDetails',
      name:'NewMeetingScheduleDetailsShort',
      component:NewMeetingScheduleDetails,
      meta:{
        title:'日程详情'
      }
    },
    //注册参会
    {
      path:'/vN/MT/register',
      name:'RegistrationShort',
      component:Registration,
      meta:{
        title:'注册参会'
      }
    }, 
    //壁报
     {
      path:'/vN/MT/eposter',
      name:'EposterShort',
      component:Eposter,
      meta:{
        title:'壁报'
      }
    }, 
    //壁报
    {
      path:'/vN/MT/eposter_link',
      name:'EposterLinkShort',
      component:EposterLink,
      meta:{
        title:'壁报'
      }
    },
    //PPT
    {
      path:'/vN/MT/ppt',
      name:'PPTShort',
      component:PPTs,
      meta:{
        title:'PPT模板'
      }
    }, 
    //手册
    {
      path:'/vN/MT/manual',
      name:'ManualShort',
      component:Manual,
      meta:{
        title:'日程手册'
      }
    }, 
    //壁报pdf
    {
      path:'/vN/pdf',
      name:'ShowPdfShort',
      component:ShowPdf,
      meta:{
        title:'PDF'
      }
    },




    //讲题征稿首页
    {
      path:'/collection/index',
      name:'ContributionIndex',
      component:contibutionIndex,
      meta:{
        title:'CEC官方',
        keepAlive: true // 需要缓存
      }
    },
    //讲题征稿联席我们
    {
      path:'/collection/contact',
      name:'ContributionContact',
      component:contibutionContact,
      meta:{
        title:'CEC官方'
      }
    },
    //讲题征稿登录
    {
      path:'/collection/login',
      name:'ContributionBind',
      component:contibutionBind,
      meta:{
        title:'CEC官方'
      }
    },
    //讲题征稿个人信息
    {
      path:'/collection/personal',
      name:'ContributionPersonal',
      component:contibutionPersonal,
      meta:{
        title:'CEC官方'
      }
    },
    //讲题征稿课题
    {
      path:'/collection/subject',
      name:'ContributionSubject',
      component:contibutionSubject,
      meta:{
        title:'CEC官方'
      }
    },
    //讲题征稿课题上报
    {
      path:'/collection/upload',
      name:'ContributionUpload',
      component:contibutionUpload,
      meta:{
        title:'CEC官方'
      }
    },
     //劳务费上报
    {
      path:'/collection/fee',
      name:'ContributionFee',
      component:contibutionFee,
      meta:{
        title:'CEC官方'
      },
    },
    //CEC2022
    {
      path:'/CEC2022/index',
      name:'cecIndex',
      component:cecIndex,
      meta:{
        title:'CEC2022'
      },
    },
    {
      path:'/CEC2023/index',
      name:'cecIndex2023',
      component:cec2023Index,
      meta:{
        title:'CEC2023'
      },
    },
    {
      path:'/CEC2022/info',
      name:'cecInfo',
      component:cecInfo,
      meta:{
        title:'大会信息'
      },
    },
    {
      path:'/CEC2022/organizor',
      name:'cecOrganizor',
      component:cecOrganizor,
      meta:{
        title:'组织机构'
      },
    },
    {
      path:'/CEC2022/contact',
      name:'cecContact',
      component:cecContact,
      meta:{
        title:'联系我们'
      },
    },
    {
      path:'/CEC2022/download',
      name:'cecDownload',
      component:cecDownload,
      meta:{
        title:'下载中心'
      },
    },
    {
      path:'/CEC2022/personal',
      name:'cecPersonal',
      component:cecPersonal,
      meta:{
        title:'个人中心'
      },
    },
    {
      path:'/CEC2022/coming',
      name:'cecComing',
      component:coming,
      meta:{
        title:'敬请期待'
      },
    },
    {
      path:'/CEC2023/coming',
      name:'cecComing2023',
      component:coming2023,
      meta:{
        title:'敬请期待'
      },
    },
    {
      path:'/CEC2023/info',
      name:'cec2023Info',
      component:cec2023Info,
      meta:{
        title:'会议信息'
      },
    },
    {
      path:'/CEC2023/schedule',
      name:'cec2023Schedule',
      component:cec2023Info,
      meta:{
        title:'日程一览'
      },
    },
    //PPT
    {
      path:'/cec2022/ppt',
      name:'CEC2022PPT',
      component:cecPPTs,
      meta:{
        title:'PPT模板'
      }
    }, 
    //静态虚拟背景
    {
      path:'/cec2022/static',
      name:'CECStatic',
      component:CECStatic,
      meta:{
        title:'静态虚拟背景'
      }
    }, 
    //动态虚拟背景
    {
      path:'/cec2022/dynamic',
      name:'CECDynamic',
      component:CECDynamic,
      meta:{
        title:'动态虚拟背景'
      }
    }, 
    {
      path:'/cec2022/zoom',
      name:'CECZoom',
      component:CECZoom,
      meta:{
        title:'zoom下载'
      }
    }, 
    {
      path:'/cec2022/virtual',
      name:'CECVirtual',
      component:CECVirtual,
      meta:{
        title:'虚拟背景下载'
      }
    }, 
    {
      path:'/cec2022/use_zoom',
      name:'CECUseZoom',
      component:CECUseZoom,
      meta:{
        title:'虚拟背景使用'
      }
    }, 
    {
      path:'/cec2022/schedule',
      name:'CECSchedule',
      component:CECSchedule,
      meta:{
        title:'日程一览'
      }
    }, 
    {
      path:'/cec2022/schedule_poster',
      name:'CECSchedulePoster',
      component:CECSchedulePoster,
      meta:{
        title:'日程总览海报'
      }
    }, 
    {
      path:'/cec2022/app_download',
      name:'CECAppDownload',
      component:CECAppDownload,
      meta:{
        title:'APP下载'
      }
    }, 
    {
      path:'/cec2022/invite',
      name:'CECInvite',
      component:CECInvite,
      meta:{
        title:'邀请函下载'
      }
    }, 
    //CVSCF2023首页
    {
      path:'/CVSCF2023/index',
      name:'CVSCF2023',
      component:cvscfIndex,
      meta:{
        title:'CVSCF2023'
      }
    }, 
    {
      path:'/CVSCF2023/download',
      name:'cvscfDownload',
      component:cvscfDownload,
      meta:{
        title:'CVSCF2023'
      }
    }, 
     //CVSCF2023酒店信息
     {
      path:'/CVSCF2023/hotel',
      name:'CVSCF2023Hotel',
      component:cvscfHotel,
      meta:{
        title:'CVSCF2023'
      }
    }, 
    {
      path:'/CVSCF2023/ppt',
      name:'cvscfPPTs',
      component:cvscfPPTs,
      meta:{
        title:'CVSCF2023'
      }
    }, 
    {
      path:'/CVSCF2023/invite',
      name:'CVSCF2023Invite',
      component:cvscfInvite,
      meta:{
        title:'邀请函下载'
      }
    }, 
    {
      path:'/TECross2023/index',
      name:'TECross2023Index',
      component:tecrossIndex,
      meta:{
        title:'TECross2023'
      }
    }, 

      //XVC首页
      {
        path:'/XVC2024/index',
        name:'XVC',
        component:xvcIndex,
        meta:{
          title:'湘雅血管论坛'
        }
      }, 
      {
        path:'/XVC2025/index',
        name:'XVC',
        component:xvcIndex2025,
        meta:{
          title:'湘雅血管论坛'
        }
      }, 
      {
        path:'/XVC/index',
        name:'XVC',
        component:xvcIndex,
        meta:{
          title:'湘雅血管论坛'
        }
      }, 
      {
        path:'/XVC/download',
        name:'xvcDownload',
        component:xvcDownload,
        meta:{
          title:''
        }
      }, 

       {
        path:'/XVC/hotel',
        name:'xvcHotel',
        component:xvcHotel,
        meta:{
          title:''
        }
      }, 
      {
        path:'/XVC/ppt',
        name:'xvcPPTs',
        component:xvcPPTs,
        meta:{
          title:''
        }
      }, 
      {
        path:'/XVC/invite',
        name:'xvcInvite',
        component:xvcInvite,
        meta:{
          title:''
        }
      }, 
      {
        path:'/XVC/history',
        name:'xvcHistory',
        component:xvcHistory,
        meta:{
          title:''
        }
      }, 
      // 注册收费
    {
      path:'/vascularNews/chargeInfo/index',
      name:'chargeInfo',
      component:ChargeInfoIndex,
      meta:{
        title:'注册收费'
      }
    }, 
    // 注册收费-填写信息
    {
      path:'/vascularNews/chargeInfo/collectInfo',
      name:'chargeCollectInfo',
      component:ChargeCollectInfo,
      meta:{
        title:'注册收费'
      }
    }, 
    {
      path:'/vascularNews/chargeInfo/order/info',
      name:'chargeCollectOrderInfo',
      component:ChargeCollecOrderInfo,
      meta:{
        title:'订单小票'
      }
    }, 
       // 购买收费
       {
        path:'/vascularNews/book/charge/index',
        name:'BookChargeInfo',
        component:BookChargeInfoIndex2,
        meta:{
          title:'购买收费'
        }
      },
         // 注册收费-填写信息
    {
      path:'/vascularNews/book/collectInfo2',
      name:'BookChargeCollectInfo2',
      component:BookChargeCollectInfo2,
      meta:{
        title:'购买收费'
      }
    }, 
    {
      path:'/nvc2025/download',
      name:'nvcDownload',
      component:nvcDownload,
      meta:{
        title:'资料下载'
      }
    }, 
  ]
})  


// WEBPACK FOOTER //
// ./src/router/index.js